export default {
    jira_details_title: "Detalles",
    jira_details_task: "Task",
    jira_details_summary: "Resumen",
    jira_details_start: "Inicio",
    jira_details_end: "Fin",
    jira_details_rejections: "Rechazados",
    jira_details_manual_rejections: "Rechazos manuales",
    jira_details_date: "Fecha",
    jira_details_no_tasks: "No hay tareas",
    jira_details_no_rejected_tasks: "No hay tareas rechazadas",
    jira_details_no_holidays: "No hay días festivos",
    jira_details_holidays: "Días festivos",
    jira_details_story_points: "Puntos de historia",
    jira_details_responsible: "Responsable",
    jira_details_issue_type: "Typo de incidencia",
    jira_details_no_responsible_tasks: "No hay incidencias como responsable",
}